import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { installGlobalErrorHandlers } from './utils/errorReporting';
import { installOfflineQueue } from './services/offlineQueue';
import { initAnalytics } from './lib/analytics';

installGlobalErrorHandlers();
installOfflineQueue();
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary name="root">
    <App />
  </ErrorBoundary>
);
